import React from 'react';
import {useFragment} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import AdvanceTableWrapper from "../../components/common/advance-table/AdvanceTableWrapper";
import {Card} from "react-bootstrap";
import AdvanceTable from "../../components/common/advance-table/AdvanceTable";
import {LinkCell} from "../../components/common/advance-table/CustomCells";
import IndexTableHeader from "../../components/common/headers/IndexTableHeader";
import AdvanceTableFooter from "../../components/common/advance-table/AdvanceTableFooter";

const cols = [
    {
        accessor: 'applicableVersion.displayName',
        Header: 'Name',
        cellProps: {className: 'py-2'},
        Cell: rowData => {
            const {applicableVersion, id} = rowData.row.original;
            return <LinkCell name={applicableVersion?.displayName} to={"/facilities/" + id}/>;
        }
    },
    {
        accessor: "npi",
        Header: "NPI",
        filter: "includes"
    }
];

const ContractFacilities = ({facilities}) => {
    const data = useFragment(graphql`
        fragment ContractFacilities_Facilities on Facility @relay(plural: true) {
            id
            applicableVersion {
                displayName
            }
            identifiers {
                identifierType {
                    code
                }
                value
            }
        }
    `, facilities);

    const mappedData = data.map(d => ({
        ...d,
        npi: Array.from(new Set(d.identifiers?.filter(x => x.identifierType.code === "NPI").map(y => y.value))).toSorted().join(", ")
    }));

    return (
        <>
            <AdvanceTableWrapper
                columns={cols}
                data={mappedData}
                sortable
                pagination
                perPage={10}
                initialSortColumn="applicableVersion.displayName"
            >
                <Card className="mb-3">
                    <Card.Header>
                        <IndexTableHeader
                            name={"Facilities"}
                            table
                            showNew={false}
                            onNewClick={() => {
                            }}
                        />
                    </Card.Header>
                    <Card.Body className="p-0">
                        <AdvanceTable
                            table
                            headerClassName="bg-200 text-900 text-nowrap align-middle"
                            rowClassName="align-middle white-space-nowrap"
                            tableProps={{
                                size: 'sm',
                                striped: true,
                                className: 'fs--1 mb-0 overflow-hidden'
                            }}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTableFooter
                            table
                            rowInfo
                            rowCount={facilities.length}
                            navButtons
                            rowsPerPageSelection
                        />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
        </>
    );
};

export default ContractFacilities;